import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=4c0f17ea&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=4c0f17ea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f17ea",
  null
  
)

export default component.exports